import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  Box,
  Button,
  Paper,
  Typography
} from '@mui/material';
import axios from 'axios';

import { useAuth } from 'hooks/use-auth';
import { isList } from 'utils';
import { Equipment } from 'models';

interface Props {
  equipment?: Equipment
}

export default function EquipmentPage({equipment}: Props) {
  return (
    <>
    {equipment && (
      <Box>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="production"
          sx={{mt: 1, ml: 1}}
          fullWidth
        >
          製作状況
        </Button>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="status"
          sx={{mt: 1, ml: 1}}
          fullWidth
        >
          稼働状況表示
        </Button>
      </Box>
    )}
    </>
  );
}
